import { graphql } from '@/graphql-setup'

export const PATCH_WORK_INFRINGEMENT_WRONGLY_GENERATED = graphql(`
  mutation PatchWorkInfringementWronglyGenerated(
    $id: ID!
    $wronglyGenerated: Boolean!
    $explanation: String
  ) {
    patchWorkInfringementWronglyGenerated(
      id: $id
      wronglyGenerated: $wronglyGenerated
      explanation: $explanation
    ) {
      workInfringement {
        id
        wronglyGenerated
        wronglyGeneratedExplanation
      }
    }
  }
`)

export const PATCH_WORK_INFRINGEMENT = graphql(`
  mutation PatchWorkInfringement(
    $id: ID!
    $solution: String
    $leadersComment: String
    $attachmentsAdd: [WorkInfringementAttachmentInput!]
    $attachmentsRemove: [ID!]
  ) {
    patchWorkInfringement(
      id: $id
      solution: $solution
      leadersComment: $leadersComment
      attachmentsAdd: $attachmentsAdd
      attachmentsRemove: $attachmentsRemove
    ) {
      workInfringement {
        id
        solution
        leadersComment
      }
    }
  }
`)

export const PATCH_WORK_INFRINGEMENT_CLOSED = graphql(`
  mutation PatchWorkInfringementClosed($id: ID!, $closed: Boolean!) {
    patchWorkInfringementClosed(id: $id, closed: $closed) {
      workInfringement {
        id
        closedAt
      }
    }
  }
`)

export const PATCH_WORK_INFRINGEMENT_ARCHIVED = graphql(`
  mutation PatchWorkInfringementArchived(
    $id: ID!
    $archived: Boolean!
    $archivedBasis: String
  ) {
    patchWorkInfringementArchived(
      id: $id
      archived: $archived
      archivedBasis: $archivedBasis
    ) {
      workInfringement {
        id
        archivedAt
        archivedBasis
      }
    }
  }
`)
